import type { OnboardingState } from '@/hooks/useOnboarding'
import { Button } from './Button'

/**
 * Standing reminder for a mobile user browsing in a tab.
 *
 * Separate from the one-time walkthrough because the cost of not installing is
 * ongoing: on iOS notifications simply do not exist outside the installed app,
 * so someone who skipped the tour silently gets none of what the portal is for.
 *
 * It snoozes for a week when dismissed rather than disappearing forever — and
 * it stops appearing on its own the moment the app is installed, since the
 * display-mode listener re-reads the platform.
 */
export function InstallNudge({ state }: { state: OnboardingState }) {
  if (!state.showInstallNudge) return null

  const ios = state.platform.platform === 'ios'

  return (
    <div className="border-b border-line bg-elevated/60">
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-2.5">
        <div className="min-w-0 flex-1">
          <p className="signage text-[10px] text-accent">Add to home screen</p>
          <p className="mt-0.5 text-xs text-muted">
            {ios
              ? 'Notifications only work from the installed app on iPhone.'
              : 'Install Hermes to get notifications when the tab is closed.'}
          </p>
        </div>

        <Button size="sm" variant="secondary" onClick={state.start}>
          Show me
        </Button>
        <button
          type="button"
          onClick={state.dismissNudge}
          aria-label="Dismiss for now"
          className="signage -mr-1 min-h-11 px-2 text-[9px] text-faint transition-colors hover:text-muted"
        >
          Later
        </button>
      </div>
    </div>
  )
}
